const mathsColors = {
  MATHS_50: '#E1F5FD',
  MATHS_100: '#B3E5FA',
  MATHS_200: '#81D4F7',
  MATHS_700: '#0088CC',
}

export default mathsColors
